import React, {  useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,

} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import SupplierServices from "services/Supplier";
import { FiDownload } from "react-icons/fi";
import pdfIcon from "assets/Icons/pdfIcon.png";
import JSZip from "jszip";


function SupplierDetailView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();


  const mockData = {
  vehicleDetails: {
    purchase_date: "2023-11-05",
    vin: "1HGBH41JXMN109186",
    veh_model: { name: "Honda Civic" },
    veh_make: { name: "Honda" },
    title_status: "Active",
    title_receive_date: "2023-12-15",
    vehicle_key: true,
    notes: "All documents in order. Ready for shipping.",
    pictures: [
      "https://static.w8shipping.com/image/car1.jpg",
      "https://static.w8shipping.com/image/car2.jpg",
    ],
    invoices_details: [
      { id: 1, invoice_attachment: "invoice1.pdf", doc_id: 1 },
      { id: 2, invoice_attachment: "invoice2.pdf", doc_id: 2 },
    ],
    vehicle: {
      container_no: "ABC123456",
      shipping: {
        container: { name: "20FT" },
        booking_no: "BOOK123456",
        ship_line: { name: "ABC Shipping" },
        loading_port: { name: "Port of Dubai" },
        dest: { name: "Port of Jebel Ali" },
        notes: "Waiting for final clearance",
        loading_date: "2023-11-10",
        export_date: "2023-11-12",
        eta: "2023-11-20",
        arrived_port_date: "2023-11-22",
        arrived_galaxy_date: "2023-11-23",
        g_yard: { name: "Galaxy Yard 1" },
      },
    },
  },
  customerDetails: {
    id: "12345",
    name: "John Doe",
    email: "johndoe@example.com",
    phone: "+1234567890",
  },
  attachments: [
    { id: 1, invoice_attachment: "invoice1.pdf", doc_id: 1 },
    { id: 2, invoice_attachment: "invoice2.pdf", doc_id: 2 },
  ],
};

  const [supplierDetails, setSupplierDetails] = useState();
console.log(supplierDetails, 'supplierDetails')
  const [activeTab, setActiveTab] = useState("vehicle-specs");
  const [openFullImage, setOpenFullImage] = useState(false);

  const images =
    supplierDetails?.pictures?.map((picture, index) => {
      if (picture.startsWith("https://static.w8shipping.com/image")) {
        return picture;
      } else {
        return process.env.REACT_APP_IMAGE_BASE_URL + picture;
      }
    }) || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const total = images.length;


  const currentImage = images[currentIndex];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveTab(sectionId);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };



   
  const attachments = mockData?.attachments || [];

  const handleAttachmentDownload = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const downloadAllImages = () => {
    const zip = new JSZip();

    const downloadPromises = supplierDetails?.pictures?.map((imagePath) =>
      fetch(`${process.env.REACT_APP_IMAGE_BASE_URL}${imagePath}`)
        .then((response) => response.blob())
        .then((data) => {
          const filename = imagePath.split("/").pop();
          zip.file(filename, data);
        })
    );

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: "blob" }).then((blob) => {
        const zipFilename = "images.zip";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = zipFilename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  const handleBackClick = () => {
    navigate("/vehicle-booking-list");
  };


   const getSupplierDataDetails = async () => {
      // setLoader(true);
  
      try {
        
        let params = {
          supplier_id: id,
        }
  
        const data = await SupplierServices.getSupplierDetail(params);
        console.log(data, '.......')
        setSupplierDetails(data?.data?.supplier)
      } catch (error) {
        ErrorToaster(error);
      }
      //  finally {
      //   setLoader(false);
      // }
    };
  
    
  
    useEffect(() => {
       getSupplierDataDetails();
    }, [])
  

  return (
    <Box sx={{ m: 4 }}>
      
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography
          sx={{
            color: "#2C6B2F",
            ml: 1,
            fontSize: "20px",
          }}
        >
          Supplier Detail View
        </Typography>     
      </Box>
    
      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Company Information
        </Typography>
        <Box id="vehicle-specs" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Company Name:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.company_name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Email:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.email ?? "-"}
                  </Typography>
                </Grid>
                
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Authorized Person:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.authorized_person ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Phone:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.phone ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2} ml={0.3} mt={0.8}>
              <Grid
                item
                xs={12}
                sm={2}
                sx={{ fontWeight: "bold", color: "#555" }}
              >
               Remarks
              </Grid>
              <Grid item xs={12} sm={10}>
                <Typography variant="body1">
                  {supplierDetails?.remarks ?? "-"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          License & Tax Information
        </Typography>
        <Box id="title-keys" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Trade License no:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.trade_license_no ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    YAT/TAX no:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {supplierDetails?.vat_tax ?? "-"}
                  </Typography>
                </Grid>
                
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Trade license Expiry:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {moment(supplierDetails?.trade_license_expiry).format('DD-MM-YYYY') ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Typography sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}>
          Bank Information
        </Typography>
        <Box id="additional-info" sx={{ mb: 3, mt: 3, ml: 2 }}>
          {/* Credit Amount & Credit Days */}
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "#555" }}>Credit Amount (AED):</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1">{supplierDetails?.supplier_banks?.[0]?.credit_amount ?? supplierDetails?.amount ? `AED ${supplierDetails?.supplier_banks?.[0]?.credit_amount ?? supplierDetails?.amount}` : "-"}</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "#555" }}>Credit Days:</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1">{supplierDetails?.supplier_banks?.[0]?.credit_days ?? supplierDetails?.credit_days ?? "-"}</Typography>
            </Grid>
          </Grid>

          {/* Bank Accounts Table */}
          {supplierDetails?.supplier_banks?.length > 0 ? (
            <TableContainer component={Paper} sx={{ mt: 1, boxShadow: "none", border: "1px solid #e0e0e0", borderRadius: 2 }}>
              <Table size="small">
                <TableHead sx={{ bgcolor: "#094526" }}>
                  <TableRow>
                    {["#", "Account Title", "Account No.", "IBAN", "Swift Code", "Country"].map((h, i) => (
                      <TableCell key={i} sx={{ color: "#fff", fontWeight: 600, whiteSpace: "nowrap" }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {supplierDetails.supplier_banks.map((b, idx) => (
                    <TableRow key={idx} sx={{ bgcolor: idx % 2 !== 0 ? "#f5f5f5" : "#fff" }}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{b.bank_name || "-"}</TableCell>
                      <TableCell>{b.account_number || "-"}</TableCell>
                      <TableCell>{b.bank_iban || "-"}</TableCell>
                      <TableCell>{b.swift_code || "-"}</TableCell>
                      <TableCell>{b.country || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" sx={{ fontWeight: "bold", color: "#555" }}>Bank:</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="body1">{supplierDetails?.bank_name || "-"}</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" sx={{ fontWeight: "bold", color: "#555" }}>IBAN:</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="body1">{supplierDetails?.bank_iban || "-"}</Typography>
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      {/* ── Billing Address ── */}
      <Box sx={{ m: 4 }}>
        <Typography sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}>
          Billing Address
        </Typography>
        <Box sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            {[
              { label: "Address",          value: supplierDetails?.address },
              { label: "City",             value: supplierDetails?.city },
              { label: "State / Province", value: supplierDetails?.province },
              { label: "Country",          value: supplierDetails?.country },
              { label: "ZIP / Postal Code",value: supplierDetails?.zip_postal },
            ].map(({ label, value }) => (
              <React.Fragment key={label}>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body1" sx={{ fontWeight: "bold", color: "#555" }}>{label}:</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body1">{value || "-"}</Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />


      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Attachments
        </Typography>

        <Box id="attachments" sx={{ mt: 3 }}>
          {/* outer container with border + radius */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            {supplierDetails?.supplier_documents.map((file, index) => (
              <Box
                key={file.id || index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                  px: 2.5,
                  py: 1.5,
                }}
              >
                <Grid container alignItems="center">
                  <Grid item xs={12} sm={8}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={pdfIcon}
                        alt="pdf"
                        sx={{ width: 26, height: 26, mr: 1.5 }}
                      />

                      <Typography
                        variant="body1"
                        sx={{ color: "#333", fontSize: "14px" }}
                      >
                        {file.doc_id === 1
                          ? "Trade License"
                          : "TAX Certificate"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", sm: "flex-end" },
                        mt: { xs: 1, sm: 0 },
                      }}
                    >
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleAttachmentDownload(file?.invoice_attachment)
                        }
                      >
                        <FiDownload size={26} />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SupplierDetailView;
